import Image from '@atoms/Image/Image';
import { IQuickLinkCard } from '@models/IQuickLinkCard';

const QuickLinkCard = ({ link, image }: IQuickLinkCard) => (
  <a href={link.url} target={link.target} key="title" className="snap-start">
    <div className="flex flex-col items-center justify-center rounded-lg bg-grey-200 px-5 py-4 text-center text-black-100 md:px-10 md:py-12 dark:bg-grey-600 dark:text-white">
      <Image image={image} />
      <p className="mt-5 text-sm md:mt-10 md:text-lg">{link.name}</p>
    </div>
  </a>
);

export default QuickLinkCard;
